import {$, w} from './constants';

w.load(() => {
    console.log('Hello world from El Cultivo! --Load');
});

$(document).ready(function() {
    console.log('Hello world from El Cultivo! --Ready');

    $("#contactForm").submit(function(){

        //Detenemos el form
        event.preventDefault();

        let form = document.getElementById('contactForm');

        let input = document.getElementById('number');

        let message_container = document.getElementById('message-block');

        $(message_container).html('');

        //Validamos el número
        if(!/^[0-9]+$/.test(input.value)){
            showMessage(message_container, 'error', '');
            return;
        }

        //Validamos que tenga 10 números
        if( input.value.length !== 10 ){
            showMessage(message_container,'error', '');
            return;
        }

        $.post(cltvo_js_vars.ajax_url, $(form).serializeArray())
            .done(function(response){

                form.reset();
                alert('Tu WhatsApp se ha registrado con éxito. Pronto nos pondremos en contacto contigo.');

            }).fail(function(error) {

                showMessage(message_container, 'error', '');

            });

    });

    /*
        Dejamos el mensaje estático por el momento, pero dejamos la función por si deciden cambiarlo
    */
    function showMessage(container, type, message){
        let message_container = document.getElementById('message-block');
        $(container).addClass('error-message').html('Introduce un número de teléfono valido. Debe de ser de 10 dígitos.');
    }

})



// WEBPACK FOOTER //
// ./es6/micorriza.js